module.exports = __webpack_public_path__ + "static/media/hushed-face-svgrepo-com.2aee8d6f.svg";